import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getSalesBlockPrimaryStyleOptions } from "../../Sales/constants";
import { createContactItemBlock } from "../../utils/layoutBlockHelpers/contactItemBlockHelper";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import {
  createBadgeBlock,
  createH1Block,
  createPBlock,
} from "../../utils/textBlocksHelpers";
import contactImagePlaceholder from "./contact_image_placeholder.png";
import envelopePlaceholder from "./envelope_image_placeholder.png";
import locationPlaceholder from "./location_image_placeholder.png";
import phonePlaceholder from "./phone_image_placeholder.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ContactBlock1",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createBadgeBlock({
          text: "Contact",
        }),
        createH1Block({
          text: "Get in Touch",
        }),
        createPBlock({
          text: "Have questions or need assistance? Contact us today—we’re here to help with all your indoor gardening needs, guidance, support, and expert advice!",
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createContactItemBlock({
          image: {
            signedId: "",
            placeholder: envelopePlaceholder,
          },
          text: "hello@courseplus.com",
        }),
        createContactItemBlock({
          image: {
            signedId: "",
            placeholder: phonePlaceholder,
          },
          text: "+1 (420) 345-3689",
        }),
        createContactItemBlock({
          image: {
            signedId: "",
            placeholder: locationPlaceholder,
          },
          text: "123 Community Street, Anytown, NY 10001",
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: contactImagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "33rem",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
      },
    },
  },
};
